module.exports = __webpack_public_path__ + "static/media/close-white.11dd7350.svg";